import { isPort } from "validator";

export default function port(str: string): string {
  return isPort(str) ? "" : "Invalid port";
}
